import { cn } from "@/lib/utils"

const mask = (asset: string) => ({
  maskImage: `url(${asset})`,
  WebkitMaskImage: `url(${asset})`,
  maskSize: "contain",
  WebkitMaskSize: "contain",
  maskPosition: "center",
  WebkitMaskPosition: "center",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
})

/** Uses the approved App artwork; currentColor supports dark and light CMS themes. */
export function ReelBrand({ showMark = true, className }: { showMark?: boolean; className?: string }) {
  return (
    <span role="img" aria-label="Reel+" className={cn("inline-flex shrink-0 items-center gap-2", className)}>
      {showMark && <img src="/logo.png" alt="" className="size-9 rounded-lg" />}
      <span aria-hidden="true" className="inline-flex items-center gap-0.5">
        <span className="h-6 w-[60px] bg-current" style={{ ...mask("/brand/reel-wordmark-type.svg"), maskSize: "76px 24px", WebkitMaskSize: "76px 24px", maskPosition: "left center", WebkitMaskPosition: "left center" }} />
        <span className="size-5 translate-y-px bg-current" style={mask("/brand/reel-sparkle.svg")} />
      </span>
    </span>
  )
}
